import { render, staticRenderFns } from "./addGoodsPage.vue?vue&type=template&id=5a55ae3f&scoped=true"
import script from "./addGoodsPage.vue?vue&type=script&lang=js"
export * from "./addGoodsPage.vue?vue&type=script&lang=js"
import style0 from "./addGoodsPage.vue?vue&type=style&index=0&id=5a55ae3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55ae3f",
  null
  
)

component.options.__file = "addGoodsPage.vue"
export default component.exports